var map = {
	"./Group-of-Schools.png": 135,
	"./address_image.svg": 136,
	"./animated_ashutosh.png": 137,
	"./animated_logo.svg": 138,
	"./blogs_image.svg": 139,
	"./cbse-logo.png": 140,
	"./cloud_infrastructure.svg": 141,
	"./codeInLogo.png": 142,
	"./contactMail.png": 143,
	"./coursera_logo.png": 144,
	"./data_science.svg": 145,
	"./deeplearning_ai_logo.png": 146,
	"./delhivery_logo.png": 147,
	"./developerActivity.svg": 148,
	"./dsc_logo.png": 149,
	"./education.svg": 150,
	"./experience.svg": 151,
	"./feelingProud.svg": 152,
	"./freecopy_logo.png": 153,
	"./fullstack.svg": 154,
	"./gcp_logo.png": 155,
	"./github_logo.png": 156,
	"./googleAssistant.jpg": 157,
	"./googleAssistant.svg": 158,
	"./google_logo.png": 159,
	"./ibm_logo.png": 160,
	"./iiitk_logo.png": 161,
	"./intel_logo.jpg": 162,
	"./jsFramework.svg": 163,
	"./legato_logo.png": 164,
	"./manOnTable.svg": 165,
	"./microsoft_logo.png": 166,
	"./mozilla_logo.png": 167,
	"./muffito_logo.png": 168,
	"./nextuLogo.jpg": 169,
	"./nptel_logo.png": 170,
	"./portfolio.gif": 171,
	"./programmer.svg": 172,
	"./projects_image.svg": 173,
	"./pwa.png": 174,
	"./saayaHealthLogo.png": 175,
	"./stanford_logo.png": 176,
	"./talksCardBack.svg": 177,
	"./talksCardBackAlt.svg": 178,
	"./ui_ux_design.svg": 179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;